import React from 'react';
import PropTypes from 'prop-types';
import { defaultTo } from 'lodash';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { getBrandId } from '../../utils/BrandUtils';

const setNameAndDataTestId = (id) => {
  return { name: id, 'data-test-id': id };
};

function HomepageAdverts({ index, advert, advertClick }) {
  const {
    id,
    image,
    heading,
    text,
    linkName,
    secondaryLinkId,
    secondaryLinkName,
    opensInANewTab = false,
  } = advert;
  const backgroundImage = defaultTo(image[getBrandId()], image.others);
  return (
    <div
      {...setNameAndDataTestId(`homepage-tile--${id}`)}
      aria-labelledby={`bfeature${index}`}
      className="c-bfeatures l-tile"
    >
      <img className="c-bfeatures__image" src={backgroundImage} alt="" />
      <div className="c-bfeatures__body">
        <h2 id={`bfeature${index}`} className="c-bfeatures__heading">
          {heading}
        </h2>
        <p className="homepage-tile-text">{text}</p>
        {/**
         * @todo FixMe: NavigationButtons are wrapped in a <div>, which can't be within a <p>
         * @note there's likely a better way of laying out these components officially with web-ui-components
         * as opposed to html with legacy classNames
         */}
        <p
          className={
            secondaryLinkName
              ? ''
              : `c-bfeatures__cta mtrack-tile__cta-btn-wrap`
          }
        >
          {secondaryLinkName && (
            <NavigationButton.Secondary
              labelText={secondaryLinkName}
              onClick={() => {
                advertClick(secondaryLinkId);
              }}
              aria-label={
                opensInANewTab
                  ? secondaryLinkName + ' (Opens in a new tab)'
                  : secondaryLinkName
              }
            />
          )}

          <NavigationButton.Primary
            labelText={linkName}
            onClick={() => {
              advertClick(id);
            }}
          />
        </p>
      </div>
    </div>
  );
}

HomepageAdverts.propTypes = {
  advert: PropTypes.shape({
    id: PropTypes.string.isRequired,
    image: PropTypes.object.isRequired,
    heading: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    linkName: PropTypes.string.isRequired,
  }).isRequired,
  advertClick: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default HomepageAdverts;
